import React from 'react';
import { createSvgIcon } from '../IconBase';

export default createSvgIcon(<path fillRule="evenodd" d="M4 11h16v2H4z" />, 'HorizontalRule');
